import useCases from '../useCases';

class Prospect {
  constructor(data) {
    this.terms = data.terms;
    this.permissions = data.permissions;
    this.install = data.install;
  }

  static async getProspectByEmail(email) {
    const result = await useCases.getLead(email);
    return result.success ? new Prospect(result.data.prospects) : {};
  }

  get acceptedTerms() {
    return this.terms;
  }

  get grantedPermissions() {
    return this.permissions;
  }

  get installedApp() {
    return this.install;
  }
}

class Lead {
  constructor(data = {}) {
    this.name = data.name;
    this.email = data.email;
    this.company = data.company;
    this.phone = data.phone;

    this.prospect =
      data.prospects instanceof Prospect
        ? data.prospects
        : new Prospect(data.prospects);
  }

  static async build(data) {
    if (Lead.hasValidProspectData(data.prospects)) {
      return new Lead(data);
    }
    const prospects = await Prospect.getProspectByEmail(data.email);
    return new Lead({ ...data, prospects });
  }

  static hasValidProspectData(prospectData = {}) {
    return (
      prospectData.terms && prospectData.permissions && prospectData.install
    );
  }
}

export { Prospect };
export default Lead;
